module.exports = __webpack_public_path__ + "images/emoji/dango.826ee7475d1f654d222d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/dango.png
// module id = TGN5
// module chunks = 13